<template>
    <div>
        <v-progress-linear
            indeterminate
            color="blue darken-2"
        ></v-progress-linear>
    </div>
</template>
<script>
export default {
    
}
</script>